import { CanvassStatus } from "../../models/canvass-status.model";

export const canvassStatusConstants = {
    political: [
        new CanvassStatus({
            id: "1",
            name: "Answered",
            color: "#14b26d",
            order: 1,
            status: "Active",
            apptype: "Walk",
            nbstatus: "answered",
            description: "A successful interaction",
        }),
        new CanvassStatus({
            id: "2",
            name: "Call Back",
            color: "#f97319",
            order: 2,
            status: "Active",
            apptype: "Walk",
            nbstatus: "left_message",
            description: "The person asked you to call back",
        }),
        new CanvassStatus({
            id: "3",
            name: "Not Interested",
            color: "#d0021b",
            order: 3,
            status: "Active",
            apptype: "Walk",
            nbstatus: "not_interested",
            description: "The person was not interested in talking to you",
        }),
        new CanvassStatus({
            id: "5",
            name: "Not Home",
            color: "#8e68c6",
            order: 4,
            status: "Active",
            apptype: "Walk",
            nbstatus: "no_answer",
            description: "There was nobody home",
        }),
        new CanvassStatus({
            id: "6",
            name: "Inaccessible",
            color: "#4986E7",
            order: 5,
            status: "Active",
            apptype: "Walk",
            nbstatus: "inaccessible",
            description: "You were unable to gain access to the front door",
        }),
    ],
    sales: [
        new CanvassStatus({
            id: 1,
            name: "Closed Won",
            description: "New customer has signed up with field sales agent",
            order: 1,
            color: "#14b26d",
            status: "Active",
            apptype: "Walk",
            nbstatus: "answered",
        }),
        new CanvassStatus({
            id: 2,
            name: "Call Back",
            description: "Customer is interested and asked to call back",
            order: 3,
            color: "#46cbf0",
            status: "Active",
            apptype: "Walk",
            nbstatus: "left_message",
        }),
        new CanvassStatus({
            id: 3,
            name: "Lost",
            description: "Person not interested in talking to you",
            order: 5,
            color: "#d0021b",
            status: "Active",
            apptype: "Walk",
            nbstatus: "not_interested",
        }),
        new CanvassStatus({
            id: 4,
            name: "Active Customer",
            description: "Customer already signed with us",
            order: 5,
            color: "#f97319",
            status: "Active",
            apptype: "Walk",
            nbstatus: "other",
        }),
        new CanvassStatus({
            id: 5,
            name: "Not Home",
            description: "Nobody was home. Field agent needs to call back",
            order: 4,
            color: "#4986E7",
            status: "Active",
            apptype: "Walk",
            nbstatus: "no_answer",
        }),
        new CanvassStatus({
            id: 6,
            name: "Lead Captured",
            description:
                "Customer has given full details and is keen to sign up",
            order: 2,
            color: "#8e68c6",
            status: "Active",
            apptype: "Walk",
            nbstatus: "meaningful_interaction",
        }),
    ],
} as const;
